import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaGoogle, FaEye, FaEyeSlash } from "react-icons/fa";
import InnerBanner from "./InnerBanner";

const SignUp = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage("❌ Passwords do not match!");
      return;
    }

    fetch('http://localhost:5000/api/auth/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: formData.username,
        email: formData.email,
        password: formData.password
      })
    })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setMessage(data.message || "✅ Registered successfully");
      })
      .catch(err => {
        console.error(err);
        setMessage("❌ Error connecting to server");
      });
  };

  return (
    <>
      <InnerBanner />
      <div className="signup-bg d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', padding: '20px' }}>
        <Container className="signup-container" style={{ maxWidth: '600px', width: '100%', backgroundColor: '#fff', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          <h2 className="signup-title text-center mb-4">Sign Up</h2>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                name="username"
                placeholder="Type your username"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Type your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3 position-relative">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Type your password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span className="password-toggle position-absolute" style={{ top: '38px', right: '10px', cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </Form.Group>

            <Form.Group className="mb-3 position-relative">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type={showConfirm ? "text" : "password"}
                name="confirmPassword"
                placeholder="Re-type your password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <span className="password-toggle position-absolute" style={{ top: '38px', right: '10px', cursor: 'pointer' }} onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
              </span>
            </Form.Group>

            <Button type="submit" className="signup-btn w-100 mb-3">
              SIGN UP
            </Button>
          </Form>

          {message && <div className="text-center mt-3" style={{color:"green", fontWeight:"bold"}}>{message}</div>}

          <div className="text-center mt-4">Or Sign Up Using</div>
          <div className="d-flex justify-content-center gap-3 mt-3">
            <div className="social-icon fb"><FaFacebookF /></div>
            <div className="social-icon tw"><FaTwitter /></div>
            <div className="social-icon gl"><FaGoogle /></div>
          </div>

          <div className="text-center mt-4">Already have an account?</div>
          <div className="login-link text-center"><Link to="/login">LOGIN</Link></div>
        </Container>
      </div>
    </>
  );
};

export default SignUp;
